<template>
	<el-container class="container" style="height: 100%">
		<el-header :span="24" class="header" height="90px">
			<el-col>
				<el-col  class="logo"> {{sysName}} </el-col>
			</el-col>
			<el-col class="myfathermenu">
				<!-- 父级导航菜单 -->
				<el-menu  class="el-menu-demo" mode="horizontal"  @select="handleselect" :default-active="activeFaIndex">
					<template v-for="item in dataFaPer" v-if="item.Ischecked">
						<!-- 一级菜单 -->
						<el-menu-item :index="item.permissionCode">
							<template  slot="title">
								<span class="el-menu-item-font" slot="title">{{item.permissionName}}</span>
						 	</template>
						</el-menu-item>
					</template>
				</el-menu>
				<el-col :span="4" class="userinfo">
					<screenfull id="screenfull" class="right-menu-item hover-effect" />
					<el-dropdown trigger="hover">
						<span class="el-dropdown-link userinfo-inner">欢迎您， {{sysUserName}}</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="handleEdit('info')">修改信息</el-dropdown-item>
							<el-dropdown-item @click.native="handleEdit('pass')">修改密码</el-dropdown-item>
							<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-col>
			</el-col>
		
		</el-header>

		<el-container style="height: 100%">
			<el-aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<!-- 子级导航菜单 -->
				<el-menu :unique-opened="false" :collapse-transition="false" mode="vertical" :default-active="activeIndex" >
					<sidebar-item v-for="route in dataChildPer" :key="route.permissionId" :item="route" />
				</el-menu>
			</el-aside>
			<el-main class="content-container" style="height: 100%;padding: 0;background: #f4f4f4;">
				<div class="grid-content bg-purple-light" style="height: 100%;">
					<tags-view  :collapsed="collapsed"   @select-type="changeTag"></tags-view>
					<el-col :span="24" class="content-wrapper"  style="width: calc(100% - 40px);height: calc(100% - 80px);margin: 20px;padding: 20px;background: #fff;position: relative;">
						<keep-alive>
							<router-view  :collapsed="collapsed"  v-if="!$route.meta.noCache"></router-view>
						</keep-alive>
							<router-view  :collapsed="collapsed"  v-if="$route.meta.noCache"></router-view>
					</el-col>
				</div>
			</el-main>
		</el-container>

		<!--Form界面-->
		<el-dialog title="修改信息" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formUser" label-width="80px" :rules="formRules" ref="formUser">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="formUser.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="登录名" prop="userName">
					<el-input v-model="formUser.userName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="系统名称" prop="sysName">
					<el-input v-model="formUser.sysName" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit('info')">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<!--修改密码界面-->
		<el-dialog title="修改密码" :visible.sync="formPassVisible" :close-on-click-modal="false">
			<el-form :model="formPass" label-width="80px" :rules="formRules" ref="formPass">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input v-model="formPass.oldPassword" auto-complete="off" type="password"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="formPass.newPassword" auto-complete="off" type="password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPas">
					<el-input v-model="formPass.checkPas" auto-complete="off" type="password"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit('pass')">取消</el-button>
				<el-button type="primary" @click.native="changePas" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</el-container>
</template>

<script>
import {updateUser,editPwd,fromIndex ,roleQueryPermisson,getFactors} from '../api/api';
import {getQueryObject,translateDataToTreePermission,in_array} from '../../static/fun.js';

import Screenfull from '../components/Screenfull/index.vue'
import tagsView from '../components/tagsView/index.vue'
import SidebarItem from '../components/sidebar/SidebarItem.vue'

export default {
	components: { Screenfull,tagsView,SidebarItem },
  	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.formPass.newPassword) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
    return {
		keyCheck:"",
		sysName: "",//系统名
		meun_size: "500px",
		sysUserName: "",//用户名
		collapsed: true,
		perStr:'',
		//修改信息相关
		formVisible: false,//编辑界面是否显示
		formPassVisible:false,//修改密码是否显示
		loading: false,
		formRules: {
			name: [
				{ required: true, message: '请输入姓名', trigger: 'blur' }
			],
			userName: [
				{ required: true, message: '请输入登录名', trigger: 'blur' }
			],
			sysName: [
				{ required: true, message: '请输入系统名称', trigger: 'blur' },
				{ max: 25,  message: '长度必须不大于25位', trigger: 'blur'}
			],
			oldPassword:[
				{ required: true, message: '请输入旧密码', trigger: 'blur' }
			],
			newPassword:[
				{ required: true, message: '请输入新密码', trigger: 'blur' },
				{ min: 8,  message: '长度必须不小于8位', trigger: 'blur'},
				{ validator: this.checkSec, trigger: 'blur' }
			],
			checkPas:[
				{ validator: validatePass, required: true, trigger: 'blur' },
				{ min: 8,  message: '长度必须不小于8位', trigger: 'blur'}
			]
		},
		//编辑界面数据
		formUser: {
			userId: 0,
			name: '',
			userName: '',
			sysName: ''
		},
		//修改密码界面数据
		formPass: {
			userId: 0,
			oldPassword: '',
			newPassword: '',
			checkPas: ''
		},
		dialogVisible:false,
		content:"暂无提醒",
		weatherVisible:false,
		dataFaPer:[],
		dataChildPer:[],
		perMap:new Map(),//父级  孩子
		menuData: [],
		activeFaIndex:"",
		activeIndex:""
    };
  },
  methods: {
	checkSec(rule, value, callback){
		this.passwordValid(value);
		if(!this.keyCheck.bPwd || this.keyCheck.degreeNumber<=2){
			
			callback(new Error(this.keyCheck.msg));
		}else{
			callback();
		}
	
	},
	changeTag(code){
		this.activeIndex=code;
	},
    handleselect(a,b) {
		this.dataChildPer=this.perMap.get(a);

		//没有子项目 默认打开父项目 收缩
		if(this.dataChildPer==undefined){
			this.collapsed=true;
			this.$router.push({ path: '/'+a });

		}else{
			this.collapsed=false;
		}
	},
    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
			sessionStorage.setItem('userId',"");
			this.$router.push({ path: '/login' });
        })
        .catch(() => {});
	},
	//信息修改显示
	handleEdit: function (type) {
		if(type=='info'){
			this.formVisible = true;
		}else if(type=='pass'){
			this.formPassVisible = true;
		}
	},
	//修改信息提交按钮
	editSubmit: function () {
		this.$refs.formUser.validate((valid) => {
			if (valid) {
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					this.loading = true;
					let para = Object.assign({}, this.formUser);
					updateUser(para).then((res) => {
						this.loading = false;
						let resData = res.data;
						if (resData.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: resData.msg,
								type: 'error'
							})
						}
						this.formVisible = false;
						this.$refs['formUser'].resetFields();
						//更改当前登录用户信息
						sessionStorage.setItem('user', JSON.stringify(para));
						this.sysUserName=para.userName;
						this.sysName=para.sysName;
					});
				});
			}
		});
	},
	passwordValid(valPwd){
		let msg = "";
		let degreeNumber = 0;
		let bPwd = false;

		if (valPwd == null || valPwd.length < 8 || valPwd.length > 24 || valPwd.trim().length == "") {
		bPwd = false;
		msg = "密码应大于8个字符，小于24个字符";
		} else {
		bPwd = true;
		}
		let arrVerify = [
		{regName: 'Number', regValue: /^.*[0-9]+.*/},
		{regName: 'LowerCase', regValue: /^.*[a-z]+.*/},
		{regName: 'UpperCase', regValue: /^.*[A-Z]+.*/},
		{regName: 'SpecialCharacters', regValue: /^.*[^a-zA-Z0-9]+.*/}
		];
		let regNum = 0;// 记录匹配的次数
		for (let iReg = 0; iReg < arrVerify.length; iReg++) {
		if (arrVerify[iReg].regValue.test(valPwd)) {
			regNum = regNum + 1;
		}
		}
		degreeNumber = regNum;
		if (regNum <= 2) {
		msg = "密码必须包含大小写字母和数字";
		}
		let objReturn = {
		msg: msg,
		degreeNumber: degreeNumber,
		bPwd: bPwd
		};
		this.keyCheck=objReturn;
	},
	// 修改密码确认按钮
	changePas:function(){
			this.$refs.formPass.validate((valid) => {
			if (valid) {
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					this.loading = true;
					let para = Object.assign({}, this.formPass);
					
					para.oldPassword=hex_md5(para.oldPassword);
					para.newPassword=hex_md5(para.newPassword);

					editPwd(para).then((res) => {
						this.loading = false;
						let resData = res.data;
						if (resData.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: resData.msg,
								type: 'error'
							})
						}
						this.formPassVisible = false;
						this.$refs['formPass'].resetFields();
					});
				});
			}
		});
	},
	//取消按钮
	cancleSubmit:function(type){
		if(type=='info'){
			this.formVisible=false;
			this.$refs.formUser.resetFields();
		}else{
			this.formPassVisible=false;
			this.$refs.formPass.resetFields();
		}
	},
    //折叠导航栏
    collapse: function() {
		this.collapsed = !this.collapsed;
    },
	initData(){
      getFactors({}).then((res) => {
			var resData = res.data.data;
            var obj
            resData.forEach(element => {
                obj={};
                obj.name=element.name;
                obj.unit=element.unit;
                obj.keyWord=element.keyword;
                obj.remark=element.remark;
                sessionStorage.setItem(element.keyword, JSON.stringify(obj));
            });
      });
    },
	//获取登录用户信息
	getLoginUser(){
		//获取id
		fromIndex({}).then((res) => {
			this.loading = false;
			let resData = res.data;
			if (resData.code != 200) {
					this.$router.push({ path: '/login' });
			}else{
				var userInfo=resData.data;
				this.sysName=userInfo.sysName || "";
				this.sysUserName=userInfo.name || "";

				this.formUser.userId=userInfo.userId||0;
				this.formPass.userId=userInfo.userId||0;
				this.formUser.name = userInfo.name || "";
				this.formUser.sysName = userInfo.sysName || "";
				this.formUser.userName = userInfo.userName || "";

				//保存经纬度
				sessionStorage.setItem('user',JSON.stringify(userInfo));
				sessionStorage.setItem('type',userInfo.role.type);
				sessionStorage.setItem('userId',userInfo.userId);

				this.initData();
				this.handlePermission(userInfo.roleId)
			}
		});
	},
	//显示授予权限界面
	handlePermission (roleId) {
		this.dataFaPer=[];
		//获取角色权限
		let para = {
			roleId:roleId
		};
		roleQueryPermisson(para).then((res) => {
			let resData = res.data;
			if (resData.code != 200) {
				this.$message({
				message: resData.msg,
				type: 'error'
			})}else{
				//处理一下Ischecked
				var checkedPermissionIds=resData.data.checkedPermissionIds;
				resData.data.permissionList.forEach(element => {
					if(in_array(element.permissionId,checkedPermissionIds)){
						element.Ischecked=true;
					}
				});
				var child=translateDataToTreePermission(resData.data.permissionList);
				
				//处理一下权限问题
				for(var i=0;i<child.length;i++){
					var ele=child[i];
					if(ele.Ischecked){
					}else if(ele.children!=undefined){
						//获取儿子，看是否有被选中的
						for(var j=0;j<ele.children.length;j++){
							if(ele.children[j].Ischecked){
								ele.Ischecked=true;
								break;
							}
						}
					}

					this.dataFaPer.push(ele);
					this.perMap.set(ele.permissionCode,ele.children);
				}

				//对菜单进行赋值
				var url=this.$route.path.split('/')[1];

				for(var i=0;i<this.dataFaPer.length;i++){
					var permissionCode=this.dataFaPer[i].permissionCode;
					var value=this.perMap.get(permissionCode);
					if(url==permissionCode){//只有一级且相等
						this.activeFaIndex=permissionCode;
						this.collapsed=true;
						break;
					}else if(value!=undefined){//有孩子
						for(var j=0;j<value.length;j++){
							var element=value[j];
							if(element.permissionCode==url){//子级相等
								this.dataChildPer=value;
								this.activeFaIndex=permissionCode;
								this.activeIndex=url;
								break;
							}else if(element.children!=undefined){//有孙子
								for(var k=0;k<element.children.length;k++){
									var son=element.children[k];
									if(son.permissionCode==url){
										this.dataChildPer=value;
										this.activeFaIndex=permissionCode;
										this.activeIndex=url;
										break;
									}
								}
							}
						}
						this.collapsed=false;
					}
				}
			}
		});
	},
  },
  mounted() {
	//判断单点登录传过来的token
	var tokenUrl=getQueryObject("token");
	if(tokenUrl!=false){
		sessionStorage.setItem("token",tokenUrl)
	}
	this.getLoginUser();
  }
};
</script>

<style scoped lang="scss">

.container {
  .header {
	width: 100%;
	padding: 0;

   
    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;
      .userinfo-inner {
        cursor: pointer;
        color: #fff;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }
    .logo {
      height: 40px;
	  line-height: 40px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
	  color:#fff;
	  font-weight: bold;
	  background: url(/static/top.png) 0 0 no-repeat;
	  background-size:cover;
    }
	.myfathermenu{
		background: #3c75ad;
		height: 50px;
		line-height: 50px;
		.el-menu-demo{
			float: left;
			
			.el-menu-item{
				height: 50px;
				line-height: 50px;
				font-size: 16px;
			}
		}
		.userinfo{
			float: right;
		}
	}
    .logo-collapse-width {
      width: 60px;
    }
	}
}

.menu-collapsed{
	flex:0 0 0;
	width: 0 !important;
	overflow: hidden;
}

.menu-expanded{
	flex:0 0 200px;
	width: 200px!important;
	background: #3c75ad;
}
.title{
	font-size: 17px;
}
.fa{
	color: #fff;
}
.main {
	display: flex;
	position: absolute;
	top: 60px;
	bottom: 0px;
	overflow: hidden;
	aside {
		flex:0 0 200px;
		width: 200px;
		.el-menu{
			height: 100%;
		}
		.collapsed{
			width:60px;
			.item{
				position: relative;
			}
			.submenu{
				position:absolute;
				top:0px;
				left:60px;
				z-index:99999;
				height:auto;
				display:none;
			}
		}
	}
	.content-container {
		flex:1;
		overflow-y: scroll;
		.breadcrumb-container {
			.title {
				width: 200px;
				float: left;
				color: #475669;
			}
			.breadcrumb-inner {
				float: right;
			}
		}
		.content-wrapper {
			background-color: #fff;
			box-sizing: border-box;
		}
	}
}

.right-menu-item {
	display: inline-block;
	padding: 0 8px;
	height: 100%;
	font-size: 18px;
	color: #5a5e66;
	vertical-align: middle;
	&.hover-effect {
		cursor: pointer;
		transition: background .3s;

		&:hover {
			background: rgba(0, 0, 0, .025)
		}
	}
}
</style>
<style lang="scss">

	.toolTip {
	position: absolute;
	bottom: 0;
	right: 2%;
}
.header img{
	height: 50px;
	padding-top:5px;
}

.el-form-item__label{
	text-align: justify; 
	text-justify:distribute-all-lines; // 这行必加，兼容ie浏览器
    text-align-last: justify;
}
.el-form{
	// padding: 0 20px ;
}
.el-form .el-input{
	width: 100%;
}

.el-form .el-select{
	width: 100%;
}

.el-menu i{
	color: #fff;
}

.el-menu{
	background: #3c75ad;
}
.el-menu .el-menu-item{
	color: #fff;
}
.el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: #ecf5ff;
}
.el-menu .el-menu-item.is-active{
	background: -webkit-gradient(linear,left top,left bottom,from(#2fbded),to(#19a9f7))!important;
    background: linear-gradient(#2fbded,#19a9f7)!important;
	color: #fff;
}
.el-menu .el-menu-item:not(.is-disabled):focus, .el-menu .el-menu-item:not(.is-disabled):hover{
	color: #fff;
	background: #ccc;
}
.el-submenu__title{
	color: #fff;
}
.el-submenu__title i{
	color: #fff;
}
.el-submenu__title:hover{
	background: #ccc;
}

a{
	text-decoration: none;
}

.amap-logo,.amap-copyright{
	display: none!important;
}
.input-item .btn{
	margin: 2px 5px;
}
</style>


// WEBPACK FOOTER //
// Home.vue?10beb556